export const apiSaleAccountExtension = {
	created: function () {
	},
	methods: {
        SaleAccountTypeListAll: async function () {
            try {

                let data = null;
                let api = $App.url.api + 'sale/AccountTypes';

                // Show progress bar
                $App.event.$emit("app_running", true)

                try {
                    let token = $App.getToken();

                    // ** ATTENTION need to add bearer token...
                    let response = await fetch(api, {
                        method: 'GET',
                        headers: {
                            'Authorization': 'Bearer ' + token
                        },
                    });

                    if (await response.ok) {
                        if (await response.status !== 204) {
                            data = await response.json();
                        }
                    } else {
                        let msg = await response.text();
                        $App.event.$emit("app_error", msg);
                    };

                } catch (error) {
                    $App.event.$emit("app_error", error);
                }

                // Hide progress bar
                $App.event.$emit("app_running", false)
                return data;

            } catch {
                if ($App && $App.event) { $App.event.$emit("app_error", error); }
                else { console.log(error); }
                return null;
            }
        },

		SaleAccountList: async function (range, callbackfct) {

			try {

				let data = null;
				let api = $App.url.api + 'sale/accounts';

				// Show progress bar
				$App.event.$emit("app_running", true)

				try {
					let token = $App.getToken();

					// ** ATTENTION need to add bearer token...
					let response = await fetch(api, {
						method: 'GET',
						mode: 'cors', // no-cors, *cors, same-origin
						cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
						credentials: 'same-origin', // include, *same-origin, omit
						headers: {
							//'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + token,
							'Range': range
						},
						redirect: 'follow', // manual, *follow, error
						referrerPolicy: 'no-referrer', // no-referrer, *client
						//body: JSON.stringify(filter)
					});

					if (await response.ok) {
						if (await response.status !== 204) {

							data = await response.json();
							if (callbackfct) { callbackfct(response); }

						}
					} else {
						let msg = await response.text();
						$App.event.$emit("app_error", msg);
					};

				} catch (error) {
					$App.event.$emit("app_error", error);
				}

				// Hide progress bar
				$App.event.$emit("app_running", false);

				return data;

			} catch (error) {
				if ($App && $App.event) { $App.event.$emit("app_error", error); }
				else { console.log(error); }
				return null;
			}
		},
		SaleAccountListWithFilter: async function (filter, range, callbackfct) {

			try {

				let data = null;
				let api = $App.url.api + 'sale/accounts/filter';

				// Show progress bar
				$App.event.$emit("app_running", true)

				try {
					let token = $App.getToken();

					// ** ATTENTION need to add bearer token...
					let response = await fetch(api, {
						method: 'PUT',
						mode: 'cors', // no-cors, *cors, same-origin
						cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
						credentials: 'same-origin', // include, *same-origin, omit
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + token,
							'Range': range
						},
						redirect: 'follow', // manual, *follow, error
						referrerPolicy: 'no-referrer', // no-referrer, *client
						body: JSON.stringify(filter)
					});

					if (await response.ok) {
						if (await response.status !== 204) {

							data = await response.json();
							if (callbackfct) { callbackfct(response); }
						}
					} else {
						let msg = await response.text();
						$App.event.$emit("app_error", msg);
					};

				} catch (error) {
					$App.event.$emit("app_error", error);
				}

				// Hide progress bar
				$App.event.$emit("app_running", false);

				return data;

			} catch (error) {
				if ($App && $App.event) { $App.event.$emit("app_error", error); }
				else { console.log(error); }
				return null;
			}
		},

        SaleAccountGetById: async function (id) {
            try {

                let data = null;
                let api = $App.url.api + 'sale/accounts/' + id;

                // Show progress bar
                $App.event.$emit("app_running", true)

                try {
                    let token = $App.getToken();

                    // ** ATTENTION need to add bearer token...
                    let response = await fetch(api, {
                        method: 'GET',
                        headers: {
                            'Authorization': 'Bearer ' + token
                        },
                    });

                    if (await response.ok) {
                        if (await response.status !== 204) {
                            data = await response.json();
                        }
                    } else {
                        let msg = await response.text();
                        $App.event.$emit("app_error", msg);
                    };

                } catch (error) {
                    $App.event.$emit("app_error", error);
                }

                // Hide progress bar
                $App.event.$emit("app_running", false)
                return data;

            } catch (error) {
                if ($App && $App.event) { $App.event.$emit("app_error", error); }
                else { console.log(error); }
                return null;
            }
        },
        SaleAccountGetByIdExpanded: async function (id) {
            //return this.SaleAccountGetByIdWithExpand(id, '?$Expand=Address.City.State;OtherEmails;OtherPhones;OtherAddresses;PaymentMethods');
            return this.SaleAccountGetByIdWithExpand(id, '?$Expand=Address.City.State;PaymentMethods');
        },
        SaleAccountGetByIdWithExpand: async function (id, expand) {
            try {

                let data = null;

                if (expand) {
                    if (!expand.startsWith('?')) { expand += '?'; }
                } else { expand = ''; }

                let api = $App.url.api + 'sale/accounts/' + id + expand;

                // Show progress bar
                $App.event.$emit("app_running", true)

                try {
                    let token = $App.getToken();

                    // ** ATTENTION need to add bearer token...
                    let response = await fetch(api, {
                        method: 'GET',
                        headers: {
                            'Authorization': 'Bearer ' + token
                        },
                    });

                    if (await response.ok) {
                        if (await response.status !== 204) {
                            data = await response.json();
                        }
                    } else {
                        let msg = await response.text();
                        $App.event.$emit("app_error", msg);
                    };

                } catch (error) {
                    $App.event.$emit("app_error", error);
                }

                // Hide progress bar
                $App.event.$emit("app_running", false)
                return data;

            } catch (error) {
                if ($App && $App.event) { $App.event.$emit("app_error", error); }
                else { console.log(error); }
                return null;
            }
        },

		SaleAccountSave: async function (input, callbackfct) {

			try {

				let data = null;
				let api = $App.url.api + 'sale/accounts';

				// Show progress bar
				$App.event.$emit("app_running", true)

				try {
					let token = $App.getToken();
					let action = 'PUT';

					if (input.id == 0) { action = 'POST'; }

					// ** ATTENTION need to add bearer token...
					let response = await fetch(api, {
						method: action,
						mode: 'cors', // no-cors, *cors, same-origin
						cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
						credentials: 'same-origin', // include, *same-origin, omit
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + token,
						},
						redirect: 'follow', // manual, *follow, error
						referrerPolicy: 'no-referrer', // no-referrer, *client
						body: JSON.stringify(input)
					});

					if (await response.ok) {
						if (await response.status !== 204) {

							data = await response.json();
							if (callbackfct) { callbackfct(response); }
						}
					} else {
						let msg = await response.text();
						$App.event.$emit("app_error", msg);
					};

				} catch (error) {
					$App.event.$emit("app_error", error);
				}

				// Hide progress bar
				$App.event.$emit("app_running", false);

				return data;

			} catch (error) {
				if ($App && $App.event) { $App.event.$emit("app_error", error); }
				else { console.log(error); }
				return null;
			}
		},
		SaleAccountDeleteById: async function (id) {
			try {

				let deleted = false;
				let api = $App.url.api + 'sale/accounts/' + id;

				// Show progress bar
				$App.event.$emit("app_running", true)

				try {
					let token = $App.getToken();

					// ** ATTENTION need to add bearer token...
					let response = await fetch(api, {
						method: 'DELETE',
						headers: {
							'Authorization': 'Bearer ' + token
						},
					});

					if (await response.ok) {
						deleted = true;
					} else {
						let msg = await response.text();
						$App.event.$emit("app_error", msg);
					};

				} catch (error) {
					$App.event.$emit("app_error", error);
				}

				// Hide progress bar
				$App.event.$emit("app_running", false)
				return deleted;

			} catch (error) {
				if ($App && $App.event) { $App.event.$emit("app_error", error); }
				else { console.log(error); }
				return false;
			}
		},

        SaleAccountAddressGetById: async function (id) {
            try {

                let data = null;
                let api = $App.url.api + 'sale/accounts/' + id + '/addresses';

                // Show progress bar
                $App.event.$emit("app_running", true)

                try {
                    let token = $App.getToken();

                    // ** ATTENTION need to add bearer token...
                    let response = await fetch(api, {
                        method: 'GET',
                        headers: {
                            'Authorization': 'Bearer ' + token
                        },
                    });

                    if (await response.ok) {
                        if (await response.status !== 204) {
                            data = await response.json();
                        }
                    } else {
                        let msg = await response.text();
                        $App.event.$emit("app_error", msg);
                    };

                } catch (error) {
                    $App.event.$emit("app_error", error);
                }

                // Hide progress bar
                $App.event.$emit("app_running", false)
                return data;

            } catch (error) {
                if ($App && $App.event) { $App.event.$emit("app_error", error); }
                else { console.log(error); }
                return null;
            }
        },		
        SaleAccountEmailGetById: async function (id) {
            try {

                let data = null;
                let api = $App.url.api + 'sale/accounts/' + id + '/emails';

                // Show progress bar
                $App.event.$emit("app_running", true)

                try {
                    let token = $App.getToken();

                    // ** ATTENTION need to add bearer token...
                    let response = await fetch(api, {
                        method: 'GET',
                        headers: {
                            'Authorization': 'Bearer ' + token
                        },
                    });

                    if (await response.ok) {
                        if (await response.status !== 204) {
                            data = await response.json();
                        }
                    } else {
                        let msg = await response.text();
                        $App.event.$emit("app_error", msg);
                    };

                } catch (error) {
                    $App.event.$emit("app_error", error);
                }

                // Hide progress bar
                $App.event.$emit("app_running", false)
                return data;

            } catch (error) {
                if ($App && $App.event) { $App.event.$emit("app_error", error); }
                else { console.log(error); }
                return null;
            }
        },		
        SaleAccountPhoneGetById: async function (id) {
            try {

                let data = null;
                let api = $App.url.api + 'sale/accounts/' + id + '/phones';

                // Show progress bar
                $App.event.$emit("app_running", true)

                try {
                    let token = $App.getToken();

                    // ** ATTENTION need to add bearer token...
                    let response = await fetch(api, {
                        method: 'GET',
                        headers: {
                            'Authorization': 'Bearer ' + token
                        },
                    });

                    if (await response.ok) {
                        if (await response.status !== 204) {
                            data = await response.json();
                        }
                    } else {
                        let msg = await response.text();
                        $App.event.$emit("app_error", msg);
                    };

                } catch (error) {
                    $App.event.$emit("app_error", error);
                }

                // Hide progress bar
                $App.event.$emit("app_running", false)
                return data;

            } catch (error) {
                if ($App && $App.event) { $App.event.$emit("app_error", error); }
                else { console.log(error); }
                return null;
            }
        },		
        // SaleAccountInvoiceGetById: async function (id) {
        //     try {

        //         let data = null;
        //         let api = $App.url.api + 'sale/accounts/' + id + '/invoices';

        //         // Show progress bar
        //         $App.event.$emit("app_running", true)

        //         try {
        //             let token = $App.getToken();

        //             // ** ATTENTION need to add bearer token...
        //             let response = await fetch(api, {
        //                 method: 'GET',
        //                 headers: {
        //                     'Authorization': 'Bearer ' + token
        //                 },
        //             });

        //             if (await response.ok) {
        //                 if (await response.status !== 204) {
        //                     data = await response.json();
        //                 }
        //             } else {
        //                 let msg = await response.text();
        //                 $App.event.$emit("app_error", msg);
        //             };

        //         } catch (error) {
        //             $App.event.$emit("app_error", error);
        //         }

        //         // Hide progress bar
        //         $App.event.$emit("app_running", false)
        //         return data;

        //     } catch (error) {
        //         if ($App && $App.event) { $App.event.$emit("app_error", error); }
        //         else { console.log(error); }
        //         return null;
        //     }
        // },

	}
}